import { render } from "./Orders.vue?vue&type=template&id=b8f49276"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__